module.exports = __webpack_public_path__ + "static/media/playlist-close.3023ee63.svg";